"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskTypesByScope = exports.tasksNeedingActionOnInvoice = exports.taskConfigMap = void 0;
var utils_1 = require("./utils");
// shorthand to create a task config
var t = function (label, priority, scope, options) { return (__assign({ label: label, priority: priority, scope: scope }, options)); };
exports.taskConfigMap = {
    A4D_CANCEL_CALLMT: t("Mission annulée par l'établissement, prévenir le transporteur", 1, 'DISPATCHER', {
        resolvable: true,
    }),
    A4D_DISPATCH_AUTO_DISPATCHING: t('En cours de dispatch automatique', 3, 'DISPATCHER'),
    A4D_DISPATCH_DISPATCHING: t('En cours de dispatch', 3, 'DISPATCHER'),
    A4D_DISPATCH_EDITED_CALLMT: t('Mission modifiée : appeler le transporteur', 2, 'DISPATCHER', {
        resolvable: true,
        segmentedByTcAssigned: true,
    }),
    A4D_DISPATCH_TO_DISPATCH: t('A dispatcher', 3, 'DISPATCHER'),
    A4D_PREBOOKED_AUTO_DISPATCHING: t('En cours de dispatch automatique', 3, 'DISPATCHER'),
    A4D_PREBOOKED_DISPATCHING: t('En cours de dispatch', 3, 'DISPATCHER'),
    A4D_PREBOOKED_TO_DISPATCH: t('A dispatcher', 3, 'DISPATCHER'),
    // --------------------
    CANCEL_CALLMT: t('Trajet(s) annulé(s), appeler le transporteur', 7, 'CANCEL', { resolvable: true }),
    CANCEL_INTEGRATION_ERROR: t('', 4, 'CANCEL', { resolvable: true }),
    // --------------------
    DISPATCH_A4D_PREBOOKED_CALLMT: t('Vérifier la disponibilité du groupement', 10.5, 'DISPATCH', { resolvable: true }),
    DISPATCH_BOOKED_CALLPATIENT: t("Transport confirmé avec départ le jour même. Vérifier s'il faut prévenir le patient", 7, 'DISPATCH', { resolvable: true, segmentedByTcAssigned: true }), // Deprecated
    DISPATCH_CALL_MF: t("Le dispatch arrive bientôt à sa fin, prévenir l'ES pour trouver une solution", 0, 'DISPATCH', {
        resolvable: true,
        segmentedByTcAssigned: true,
    }),
    DISPATCH_CHECK_GOV_FLATRATE: t("Forfait à vérifier, un AS publié alors qu'un AR était attendu", 12, 'DISPATCH', {
        resolvable: true,
        segmentedByTcAssigned: true,
    }),
    DISPATCH_CHECK_UNKNOWN_ADDR: t("L'adresse ne correspond pas à celle de l'établissement, vérifier le prescripteur et payeur", 12.5, 'DISPATCH', { resolvable: true, segmentedByTcAssigned: true }),
    DISPATCH_DISPATCHING: t('En cours de dispatch', 20, 'DISPATCH', { segmentedByTcAssigned: true }),
    DISPATCH_RESEND_BR_RAVENS_SCHEDULED: t('Relance programmée', 20, 'DISPATCH', { segmentedByTcAssigned: true }),
    DISPATCH_EDITED_CALLMT: t('Mission modifiée : appeler le transporteur assigné', 14, 'DISPATCH', { resolvable: true }),
    DISPATCH_EDITED_NOACCOUNT: t('Mission modifiée : transporteur sans compte à prévenir', 15.2, 'DISPATCH', {
        segmentedByTcAssigned: true,
    }),
    DISPATCH_INTEGRATION_ERROR: t('', 4, 'DISPATCH', { resolvable: true, segmentedByTcAssigned: true }),
    DISPATCH_NOT_ASSIGNED_TC_TIMEOUT: t('Mission expirée : aucun agent assigné', 2, 'DISPATCH', { resolvable: true }),
    DISPATCH_NOT_CONFIRMED_CALLMF: t("Commande non finalisée : appeler l'etablissement", 17, 'DISPATCH', {
        resolvable: true,
    }),
    DISPATCH_PREBOOKED_CALLMT: t('Vérifier la disponibilité du transporteur réservé', 10, 'DISPATCH', { resolvable: true }),
    DISPATCH_SET_MISSING_PAYER: t('Renseigner le prescripteur & payeur', 11, 'DISPATCH', { segmentedByTcAssigned: true }),
    DISPATCH_TO_DISPATCH: t('A dispatcher', 19, 'DISPATCH', { segmentedByTcAssigned: true }),
    DISPATCH_TPTR_NOT_FOUND_TIMEOUT: t('Mission expirée : aucun transporteur trouvé', 1, 'DISPATCH', { resolvable: true }),
    DISPATCH_WATCH_PREFERRED_MT: t('Le patient veut choisir son transporteur', 16, 'DISPATCH', {
        resolvable: true,
        segmentedByTcAssigned: true,
    }),
    DISPATCH_MT_COUNTEROFFER: t("Un TS a proposé un autre horaire. Appeler l'ES", 18, 'DISPATCH', { resolvable: true }),
    // --------------------
    INCIDENT_RESOLVE_MAJOR_INCIDENT: t('', 5, 'INCIDENT'),
    INCIDENT_RESOLVE_MINOR_INCIDENT: t('', 6, 'INCIDENT', { resolvable: true }),
    // --------------------
    INVOICING_CHECK_POST_APPROVAL_MODIFICATION: t('Modification à vérifier sur une facture validée', 1, 'INVOICING', {
        needsActionOnInvoice: true,
    }),
    INVOICING_INVOICE_TO_BE_SENT_MANUALLY: t("Envoyer la facture manuellement à l'établissement", 2, 'INVOICING', {
        resolvable: true,
        needsActionOnInvoice: true,
    }),
    PASSENGER_PENDING_TC_CONFIRMATION: t('Valider la modification des informations de facturation', 2, 'INVOICING'),
    INVOICING_MISSING_TRIPS: t("Demande d'ajout d'un transport", 3, 'INVOICING'), // deprecated
    INVOICING_MISSING_TRIP: t("Demande d'ajout d'un transport", 3, 'INVOICING'),
    INVOICING_MISSING_DI: t("Demande d'ajout de d\u00E9placement inutile", 3, 'INVOICING', { resolvable: true }),
    INVOICING_RELAUNCH_INVOICE: t('Relancer la facturation', 3, 'INVOICING', { needsActionOnInvoice: true }),
    INVOICING_PENDING_MT_APPROVAL_5D: t('Relancer le transporteur : facture en attente depuis 5 jours', 4, 'INVOICING', {
        resolvable: true,
        needsActionOnInvoice: true,
    }),
    INVOICING_PENDING_MT_APPROVAL_10D: t('Relancer le transporteur : facture en attente depuis 10 jours', 4, 'INVOICING', { resolvable: true, needsActionOnInvoice: true }),
    INVOICING_PENDING_MT_APPROVAL_20D: t('Relancer le transporteur : facture en attente depuis 20 jours', 4, 'INVOICING', { resolvable: true, needsActionOnInvoice: true }),
    INVOICING_PENDING_MT_APPROVAL_FINAL: t('Relancer le transporteur : facture en attente depuis 30 jours', 4, 'INVOICING', { needsActionOnInvoice: true }),
    PASSENGER_SET_MISSING_PAYMENT: t('Renseigner le statut de paiement', 11.5, 'INVOICING'),
    // --------------------
    MANUAL_INVOICING_CHECK_PASSENGER_INCIDENT_RESOLUTION: t("Se référer à la résolution de l'incident", 1, 'MANUAL_INVOICING', { resolvable: true }),
    MANUAL_INVOICING_SEND_INVOICE: t('FTS à vérifier et à envoyer', 3, 'MANUAL_INVOICING'),
    MANUAL_INVOICING_SEND_MODIFIED_INVOICE: t('FTS modifiée à vérifier et envoyer', 2, 'MANUAL_INVOICING'),
    MANUAL_INVOICING_UPLOAD_INVOICE: t("Importer une nouvelle FTS et l'envoyer", 4, 'MANUAL_INVOICING'),
    MANUAL_INVOICING_MISSING_TRIP: t("Demande d'ajout d'un transport", 3, 'MANUAL_INVOICING'),
    MANUAL_INVOICING_MISSING_DI: t("Demande d'ajout de d\u00E9placement inutile", 3, 'MANUAL_INVOICING', { resolvable: true }),
    // --------------------
    ACCOUNTING_CHECK_MODIFICATION_REQUEST: t('Modification(s) à vérifier sur une facture émise', 1, 'AMBLER_INVOICING'),
    ACCOUNTING_RELAUNCH_INVOICING: t('Relancer la facturation', 1, 'AMBLER_INVOICING'),
    ACCOUNTING_SEPA_EXPIRED: t('Le TS a résilié son mandat SEPA, contactez le pour lui demander de payer sa facture par virement', 1, 'AMBLER_INVOICING', { resolvable: true }),
    ACCOUNTING_EMAILS_BLOCKED: t("Nous n'avons pas réussi à envoyer la facture / l'avoir. Vérifiez les ravens manuellement.", 1, 'AMBLER_INVOICING', { resolvable: true }),
    ACCOUNTING_UPLOAD_TO_CHORUS: t('Facture à déposer sur Chorus Pro', 2, 'AMBLER_INVOICING', { resolvable: true }),
    // --------------------
    OPTIM_PATIENT_TO_ADD: t("Patient à rajouter à l'optimisation existante", 19, 'OPTIM'),
    OPTIM_TO_CREATE: t("En attente d'optimisation", 1, 'OPTIM'),
    // --------------------
    // ? Tasks of type FLAG won't be visible in the BO but only used to trigger an action
    HIDDEN_URGENT_DISPATCH_IS_SOON: t('', 4, 'HIDDEN'),
};
exports.tasksNeedingActionOnInvoice = (0, utils_1.getEntries)(exports.taskConfigMap)
    .filter(function (_a) {
    var config = _a[1];
    return config.needsActionOnInvoice;
})
    .map(function (_a) {
    var type = _a[0];
    return type;
});
exports.taskTypesByScope = (0, utils_1.getEntries)(exports.taskConfigMap).reduce(function (prev, _a) {
    var type = _a[0], config = _a[1];
    if (!prev[config.scope]) {
        prev[config.scope] = [];
    }
    prev[config.scope].push(type);
    return prev;
}, {});
//# sourceMappingURL=tasks.js.map